<template>
  <div class="WordSection1" style='layout-grid:18.0pt' v-if="item">

    <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="99%"
           style='border-collapse:collapse'>
      <tr style='height:42.55pt'>
        <td width="100%" nowrap colspan=9 style='width:100.0%;padding:0in 1.4pt 0in 1.4pt;
  height:42.55pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-size:28.0pt;font-family:"Microsoft JhengHei",sans-serif;
  color:black'>{{ item.category }}</span><span style='font-size:28.0pt;font-family:"Microsoft JhengHei",sans-serif;
  color:black'>憑證</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="100%" nowrap colspan=9 style='width:100.0%;padding:0in 1.4pt 0in 1.4pt;
  height:28.35pt'>
          <p class=MsoNormal><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>  <span lang=ZH-TW>流水編號：</span></span><span lang=ZH-TW
                                                               style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'></span><span style='font-size:10.0pt;font-family:"Microsoft JhengHei",sans-serif;
  color:black'>{{ item.docId }}-{{ item.docNo }}</span></p>
        </td>
      </tr>
      <tr style='height:25.5pt'>
        <td width="26%" rowspan=3 style='width:26.2%;border:solid windowtext 1.0pt;
  border-right:none;padding:0in 1.4pt 0in 1.4pt;height:25.5pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>部　　　門</span><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>     
  (<span lang=ZH-TW>請勾選</span>)</span></p>
        </td>
        <td width="10%" nowrap valign=top style='width:10.4%;border-top:solid windowtext 1.0pt;
  border-left:solid windowtext 1.0pt;border-bottom:none;border-right:none;
  padding:0in 1.4pt 0in 1.4pt;height:25.5pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.department === '六A' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>六</span><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>A</span></p>
        </td>
        <td width="19%" nowrap colspan=2 rowspan=3 style='width:19.0%;border:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:25.5pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>無法取得單據事由</span></p>
        </td>
        <td width="44%" colspan=5 rowspan=3 style='width:44.4%;border:solid windowtext 1.0pt;
  border-left:none;padding:0in 1.4pt 0in 1.4pt;height:25.5pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>{{item.noDocReason}}</span></p>
        </td>
      </tr>
      <tr style='height:25.5pt'>
        <td width="10%" nowrap valign=top style='width:10.4%;border-left:solid windowtext 1.0pt;padding:0in 1.4pt 0in 1.4pt;height:25.5pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.department === '六B' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>六</span><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>B</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="10%" nowrap valign=bottom style='width:10.4%;border-left:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;
  border-right:none;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.department === '九總' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>九總</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="26%" rowspan=4 style='width:26.2%;border-left:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;border-right:
  solid black 1.0pt;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>證明票據種類</span><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>    (<span
            lang=ZH-TW>請勾選</span>)</span></p>
        </td>
        <td width="10%" nowrap style='width:10.4%;border-left:solid windowtext 1.0pt;border-right:none;border-bottom:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.invoiceType === '收據' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>收據</span></p>
        </td>
        <td width="9%" nowrap style='width:9.72%;border-bottom:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.invoiceType === '估價單' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>估價單</span></p>
        </td>
        <td width="19%" nowrap colspan=2 style='width:19.86%;border-bottom:
  solid windowtext 1.0pt;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"PMingLiU",serif;color:black'>{{ item.invoiceType === '二聯式發票' ? '■': '□'}}</span><span lang=ZH-TW
                                                                                                                                         style='font-family:"Microsoft JhengHei",sans-serif;color:black'>二聯式發票</span></p>
        </td>
        <td width="33%" nowrap colspan=4 style='width:33.82%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"PMingLiU",serif;
  color:black'>{{ item.invoiceType === '三聯式發票' ? '■': '□'}}</span><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>三聯式發票</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="73%" nowrap colspan=8 valign=top style='width:73.8%;border-top:solid windowtext 1.0pt;border-left:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>單據號碼：{{ item.invoiceNumber }}</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="73%" nowrap colspan=8 valign=top style='width:73.8%;border-top:
  none;border-left:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>二聯發票號碼：{{ item.invoiceNumberV2 }}</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="73%" nowrap colspan=8 valign=top style='width:73.8%;border-top:
  none;border-left:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>三聯發票號碼：{{ item.invoiceNumberV3 }}</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="26%" nowrap style='width:26.2%;border:solid windowtext 1.0pt;
  border-top:none;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>{{ item.category === '收入' ? '廠商':'客戶' }}　　資料</span></p>
        </td>
        <td width="73%" nowrap colspan=8 valign=top style='width:73.8%;border-top:
  none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>名稱</span><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>:{{item.vendor}}<span lang=ZH-TW>　　　　　　　電話：{{item.vendorPhone}}　　　　　　地址：{{item.vendorAddress}}</span></span></p>
        </td>
      </tr>
      <tr style='height:56.7pt'>
        <td width="26%" nowrap style='width:26.2%;border-top:none;border-left:solid windowtext 1.0pt;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0in 1.4pt 0in 1.4pt;
  height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>收 支 用 途</span></p>
        </td>
        <td width="73%" colspan=8 style='width:73.8%;border:solid windowtext 1.0pt;border-right:solid black 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>&nbsp;{{item.reason}}</span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="26%" nowrap rowspan=2 style='width:26.2%;border:solid windowtext 1.0pt;
  border-bottom:solid black 1.0pt;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>交 易 方 式</span></p>
        </td>
        <td width="73%" nowrap colspan=8 valign=bottom style='width:73.8%;border-top:
  solid windowtext 1.0pt;border-left:none;border-bottom:solid windowtext 1.0pt;
  border-right:solid black 1.0pt;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>{{ item.tradeType === '現金' ? '●': '○'}}現金　{{ item.tradeType === '匯款' ? '●': '○'}}匯款 <u>　　　　　　　</u></span><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>  {{item.bankName}}<span lang=ZH-TW>銀行　帳號</span>:<span lang=ZH-TW>{{item.bankAccount}}</span></span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="73%" nowrap colspan=8 valign=bottom style='width:73.8%;border-top:
  none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid black 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>{{ item.tradeType === '支票' ? '●': '○'}}支票 <u>　　　　　　</u></span><span style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'> {{item.bankName}}<span lang=ZH-TW>銀行　票號</span>:{{item.chequeNumber}}<span lang=ZH-TW>　　　　　　　　到期日</span>:{{item.chequeExpireTime}}<span
            lang=ZH-TW>　　　　　　　　</span></span></p>
        </td>
      </tr>
      <tr style='height:28.35pt'>
        <td width="26%" nowrap style='width:26.2%;border:solid windowtext 1.0pt;
  border-top:none;padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>金　　　額</span></p>
        </td>
        <td width="73%" nowrap colspan=8 style='width:73.8%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:28.35pt'>
          <p class=MsoNormal><span lang=ZH-TW style='font-family:"Microsoft JhengHei",sans-serif;
  color:black'>新台幣　{{item.amount}}　元整</span></p>
        </td>
      </tr>
      <tr style='height:30.7pt'>
        <td width="26%" nowrap rowspan=2 style='width:26.2%;border:solid windowtext 1.0pt;
  border-top:none;padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>核　　　簽</span></p>
        </td>
        <td width="10%" nowrap valign=top style='width:10.4%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>董事長</span></p>
        </td>
        <td width="9%" nowrap valign=top style='width:9.72%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>經理</span></p>
        </td>
        <td width="9%" nowrap valign=top style='width:9.28%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>會計</span></p>
        </td>
        <td width="10%" nowrap valign=top style='width:10.58%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>承辦會計</span></p>
        </td>
        <td width="7%" nowrap valign=top style='width:7.94%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>總務</span></p>
        </td>
        <td width="7%" nowrap valign=top style='width:7.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>出納</span></p>
        </td>
        <td width="8%" nowrap valign=top style='width:8.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>經手人</span></p>
        </td>
        <td width="8%" nowrap valign=top style='width:8.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:30.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span lang=ZH-TW
                                                                          style='font-family:"Microsoft JhengHei",sans-serif;color:black'>領受人</span></p>
        </td>
      </tr>
      <tr style='height:56.7pt'>
        <td width="10%" nowrap valign=top style='width:10.4%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="9%" nowrap valign=top style='width:9.72%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="9%" nowrap valign=top style='width:9.28%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="10%" nowrap valign=top style='width:10.58%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="7%" nowrap valign=top style='width:7.94%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="7%" nowrap valign=top style='width:7.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="8%" nowrap valign=top style='width:8.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>&nbsp;</span></p>
        </td>
        <td width="8%" nowrap valign=top style='width:8.96%;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 1.4pt 0in 1.4pt;height:56.7pt'>
          <p class=MsoNormal align=center style='text-align:center'><span
            style='font-family:"Microsoft JhengHei",sans-serif;color:black'>{{item.applicant}}</span></p>
        </td>
      </tr>
      <tr style='height:56.7pt'>
        <td width="100%" nowrap colspan=9 style='width:100.0%;padding:0in 1.4pt 0in 1.4pt;
  height:56.7pt'>
          <p class="MsoNormal" align="center" style="text-align:left">
<!--            <b>-->
<!--            <span-->
<!--            lang=ZH-TW style='font-size:20.0pt;font-family:"Microsoft JhengHei",sans-serif;-->
<!--  color:black'>單 據 釘 製 處</span>-->
<!--            </b>-->
            <img v-if="item.imageURL1 !== ''" :src="item.imageURL1" style="max-height: 500px; max-width: 50%;">
            <img v-if="item.imageURL2 !== ''" :src="item.imageURL2" style="max-height: 500px; max-width: 50%;">
          </p>
        </td>
      </tr>
      <tr style='height:56.7pt'>
        <td width="100%" nowrap colspan=9 style='width:100.0%;padding:0in 1.4pt 0in 1.4pt;
  height:56.7pt'>
          <p class="MsoNormal" align="center" style="text-align:left">
            <img v-if="item.imageURL3 !== ''" :src="item.imageURL3" style="max-height: 500px; max-width: 50%;">
            <img v-if="item.imageURL4 !== ''" :src="item.imageURL4" style="max-height: 500px; max-width: 50%;">
          </p>
        </td>
      </tr>
      <tr style='height:56.7pt'>
        <td width="100%" nowrap colspan=9 style='width:100.0%;padding:0in 1.4pt 0in 1.4pt;
    height:56.7pt'>
          <p class="MsoNormal" align="center" style="text-align:left">
            <img v-if="item.imageURL5 !== ''" :src="item.imageURL5" style="max-height: 500px; max-width: 50%;">
          </p>
        </td>
      </tr>
    </table>

    <p class=MsoNormal>&nbsp;</p>

  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CompanyDocView',
  data(){
    return {
      item: null,
    }
  },
  created() {
    this.loadData();
  },
  methods:{
    ...mapActions(['getDocInfo']),
    async loadData(){
      const docId = this.$route.query.docId;
      if (docId && docId !== ''){
        const res = await this.getDocInfo({
          docId
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.item = result.data;
          console.log(`getDocInfo = ${JSON.stringify(this.item)}`);
        }
      }
    }
  }
};
</script>

<style scoped>
@font-face
{font-family:PMingLiU;
  panose-1:2 2 5 0 0 0 0 0 0 0;}
@font-face
{font-family:"Cambria Math";
  panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
{font-family:Calibri;
  panose-1:2 15 5 2 2 2 4 3 2 4;}
@font-face
{font-family:"Microsoft JhengHei";
  panose-1:2 11 6 4 3 5 4 4 2 4;}
@font-face
{font-family:"\@Microsoft JhengHei";}
@font-face
{font-family:"\@PMingLiU";
  panose-1:2 1 6 1 0 1 1 1 1 1;}
/* Style Definitions */
p.MsoNormal, li.MsoNormal, div.MsoNormal
{margin:0in;
  font-size:12.0pt;
  font-family:"Calibri",sans-serif;}
.MsoChpDefault
{font-size:12.0pt;
  font-family:"Calibri",sans-serif;}
/* Page Definitions */
@page WordSection1
{size:595.3pt 841.9pt;
  margin:8.5pt 28.35pt 8.8pt 28.35pt;
  layout-grid:18.0pt;}
div.WordSection1
{page:WordSection1; max-width: 800px; margin: 0 auto;}
</style>



// WEBPACK FOOTER //
// src/pages/web/CompanyDocView.vue